// @flow
import React, { Component } from "react";
import { SizeMe } from "react-sizeme";
import ReactMapGL, { Marker } from "react-map-gl";
import pinIcon from "../../../../images/breachroom-pin.svg";
import styles from "./Map.module.css";

type Props = {
  latitude: number,
  longitude: number
};

type State = {
  viewport: MapGLViewport
};

class Map extends Component<Props, State> {
  state = {
    viewport: {
      width: 640,
      height: 640,
      latitude: this.props.latitude,
      longitude: this.props.longitude,
      zoom: 9
    }
  };

  render() {
    const { viewport } = this.state;
    const { latitude, longitude } = this.props;
    return (
      <SizeMe>
        {({ size }) => (
          <div className={styles.map}>
            <ReactMapGL
              {...viewport}
              width={size.width}
              mapStyle="mapbox://styles/mukealicious/cjkafe3og08ia2rpsduvrotrt"
              onViewportChange={nextViewport =>
                this.setState({ viewport: nextViewport })
              }
              mapboxApiAccessToken="pk.eyJ1IjoibXVrZWFsaWNpb3VzIiwiYSI6ImNqazhzenNiZDF0YXIzcG5jOWt5bzlxMDMifQ.UZVPfZw_s-yWw2Zf1yIazw"
            >
              <Marker
                latitude={latitude}
                longitude={longitude}
                offsetLeft={-24}
                offsetTop={-24}
              >
                <img src={pinIcon} alt="breach" />
              </Marker>
            </ReactMapGL>
          </div>
        )}
      </SizeMe>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Breach/BreachNews/Map/Map.js